import React, { FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import classes from './LiveStreamCardItem.module.scss'

import { StartTimeInfo } from './components/StartTimeInfo/StartTimeInfo'
import { LiveStreamInfo } from './components/LiveStreamInfo/LiveStreamInfo'
import { LiveStreamThumbnail } from './components/LiveStreamThumbnail/LiveStreamThumbnail'
import { FooterInfo } from './components/FooterInfo/FooterInfo'

type LiveStreamCardItemProps = {
  item: FeedData
}

export const LiveStreamCardItem: FC<LiveStreamCardItemProps> = ({ item }) => {
  return (
    <div className={classes.Container}>
      <div className={classes.Body}>
        <LiveStreamThumbnail imgSrc={item.thumbnailImageUrl} />
        <div className={classes.Info}>
          <StartTimeInfo startTime={item.startTime} />
          <LiveStreamInfo title={item.title} />
        </div>
      </div>
      <FooterInfo game={item} />
    </div>
  )
}
